export default __webpack_public_path__ + "static/media/img7.c34e2267.png";